import {
  ChangeDetectionStrategy,
  Component,
  EventEmitter,
  forwardRef,
  HostBinding,
  Input,
  Output,
} from '@angular/core';
import { ControlValueAccessor, FormsModule, NG_VALUE_ACCESSOR, ReactiveFormsModule } from '@angular/forms';

@Component({
  selector: 'sd-switch',
  templateUrl: './switch.component.html',
  styleUrls: ['./switch.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [FormsModule, ReactiveFormsModule],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => SwitchComponent),
      multi: true,
    },
  ],
})
export class SwitchComponent implements ControlValueAccessor {
  @Input() name: string;
  @Input() checked: boolean;

  /**
   * В неактивном состоянии
   */
  @Input() @HostBinding('class.disabled') disabled = false;

  /**
   * Изменение состояния
   * ВНИМАНИЕ! change свойство у объекта эмитит Event, поэтому changed
   */
  @Output() changed = new EventEmitter<boolean>();

  @HostBinding('class')
  get classNames(): string[] {
    return ['switch'];
  }

  private onChange: (_: any) => void;
  private onTouched: (_: any) => void;

  writeValue(value: boolean): void {
    this.checked = value;
  }

  registerOnChange(fn: any): void {
    this.onChange = fn;
  }

  registerOnTouched(fn: any): void {
    this.onTouched = fn;
  }

  setDisabledState(isDisabled: boolean): void {
    this.disabled = isDisabled;
  }

  inputOnChange(value: boolean): void {
    this.changed.emit(value);

    if (this.onChange) {
      this.onChange(value);
    }
    if (this.onTouched) {
      this.onTouched(value);
    }
  }
}
